import { render, staticRenderFns } from "./StoryOverlayController.vue?vue&type=template&id=36b5f41a&scoped=true&"
import script from "./StoryOverlayController.vue?vue&type=script&lang=ts&"
export * from "./StoryOverlayController.vue?vue&type=script&lang=ts&"
import style0 from "./StoryOverlayController.vue?vue&type=style&index=0&id=36b5f41a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b5f41a",
  null
  
)

export default component.exports